import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageValladolid = props => {
  return <CityLandingPage cityKey="Valladolid" cityConfig={cityContent.valladolid} {...props} />;
};

export default LandingPageValladolid;
